import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Calculator, FileText, Building2, Users, Receipt, BookOpen, ArrowUpRight } from 'lucide-react';
import { useLang } from '../contexts/LanguageContext';
export function Services() {
  const {
    t
  } = useLang();
  const scrollToContact = () => document.getElementById('contact')?.scrollIntoView({
    behavior: 'smooth'
  });
  return <Section id="services" background="white" data-id="element-237">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-12 md:mb-24 gap-4 md:gap-6" data-id="element-238">
        <div className="max-w-2xl" data-id="element-239">
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-black mb-4 md:mb-6" data-id="element-240">
            {t('services_h2')}
          </h2>
          <p className="text-neutral-500 text-base md:text-lg font-light" data-id="element-241">
            {t('services_subtitle')}
          </p>
        </div>
        <Button variant="outline" className="w-full sm:w-auto" onClick={scrollToContact} data-id="element-242">
          {t('services_all')}
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-neutral-200" data-id="element-243">
        {/* Service 1 */}
        <div className="group p-6 md:p-8 border-r border-b border-neutral-200 hover:bg-neutral-50 transition-all duration-300 cursor-pointer relative" onClick={scrollToContact} data-id="element-244">
          <div className="absolute top-6 md:top-8 right-6 md:right-8 opacity-0 group-hover:opacity-100 group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300" data-id="element-245">
            <ArrowUpRight className="h-4 md:h-5 w-4 md:w-5 text-black" data-id="element-246" />
          </div>
          <div className="mb-6 md:mb-8 group-hover:scale-110 transition-transform duration-300 origin-left" data-id="element-247">
            <Calculator className="h-5 md:h-6 w-5 md:w-6 text-black stroke-[1.5]" data-id="element-248" />
          </div>
          <h3 className="text-lg md:text-xl font-bold text-black mb-3 group-hover:underline decoration-1 underline-offset-4 transition-all" data-id="element-249">
            {t('svc1_title')}
          </h3>
          <p className="text-neutral-500 mb-6 md:mb-8 text-sm leading-relaxed min-h-[3rem]" data-id="element-250">
            {t('svc1_desc')}
          </p>
          <div className="flex items-center" data-id="element-251">
            <span className="text-black font-medium text-sm border-b border-neutral-200 group-hover:border-black transition-colors pb-0.5" data-id="element-252">
              {t('svc1_price')}
            </span>
          </div>
        </div>

        {/* Service 2 */}
        <div className="group p-6 md:p-8 border-r border-b border-neutral-200 hover:bg-neutral-50 transition-all duration-300 cursor-pointer relative" onClick={scrollToContact} data-id="element-253">
          <div className="absolute top-6 md:top-8 right-6 md:right-8 opacity-0 group-hover:opacity-100 group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300" data-id="element-254">
            <ArrowUpRight className="h-4 md:h-5 w-4 md:w-5 text-black" data-id="element-255" />
          </div>
          <div className="mb-6 md:mb-8 group-hover:scale-110 transition-transform duration-300 origin-left" data-id="element-256">
            <FileText className="h-5 md:h-6 w-5 md:w-6 text-black stroke-[1.5]" data-id="element-257" />
          </div>
          <h3 className="text-lg md:text-xl font-bold text-black mb-3 group-hover:underline decoration-1 underline-offset-4 transition-all" data-id="element-258">
            {t('svc2_title')}
          </h3>
          <p className="text-neutral-500 mb-6 md:mb-8 text-sm leading-relaxed min-h-[3rem]" data-id="element-259">
            {t('svc2_desc')}
          </p>
          <div className="flex items-center" data-id="element-260">
            <span className="text-black font-medium text-sm border-b border-neutral-200 group-hover:border-black transition-colors pb-0.5" data-id="element-261">
              {t('svc2_price')}
            </span>
          </div>
        </div>

        {/* Service 3 */}
        <div className="group p-6 md:p-8 border-r border-b border-neutral-200 hover:bg-neutral-50 transition-all duration-300 cursor-pointer relative" onClick={scrollToContact} data-id="element-262">
          <div className="absolute top-6 md:top-8 right-6 md:right-8 opacity-0 group-hover:opacity-100 group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300" data-id="element-263">
            <ArrowUpRight className="h-4 md:h-5 w-4 md:w-5 text-black" data-id="element-264" />
          </div>
          <div className="mb-6 md:mb-8 group-hover:scale-110 transition-transform duration-300 origin-left" data-id="element-265">
            <Building2 className="h-5 md:h-6 w-5 md:w-6 text-black stroke-[1.5]" data-id="element-266" />
          </div>
          <h3 className="text-lg md:text-xl font-bold text-black mb-3 group-hover:underline decoration-1 underline-offset-4 transition-all" data-id="element-267">
            {t('svc3_title')}
          </h3>
          <p className="text-neutral-500 mb-6 md:mb-8 text-sm leading-relaxed min-h-[3rem]" data-id="element-268">
            {t('svc3_desc')}
          </p>
          <div className="flex items-center" data-id="element-269">
            <span className="text-black font-medium text-sm border-b border-neutral-200 group-hover:border-black transition-colors pb-0.5" data-id="element-270">
              {t('svc3_price')}
            </span>
          </div>
        </div>

        {/* Service 4 */}
        <div className="group p-6 md:p-8 border-r border-b border-neutral-200 hover:bg-neutral-50 transition-all duration-300 cursor-pointer relative" onClick={scrollToContact} data-id="element-271">
          <div className="absolute top-6 md:top-8 right-6 md:right-8 opacity-0 group-hover:opacity-100 group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300" data-id="element-272">
            <ArrowUpRight className="h-4 md:h-5 w-4 md:w-5 text-black" data-id="element-273" />
          </div>
          <div className="mb-6 md:mb-8 group-hover:scale-110 transition-transform duration-300 origin-left" data-id="element-274">
            <Users className="h-5 md:h-6 w-5 md:w-6 text-black stroke-[1.5]" data-id="element-275" />
          </div>
          <h3 className="text-lg md:text-xl font-bold text-black mb-3 group-hover:underline decoration-1 underline-offset-4 transition-all" data-id="element-276">
            {t('svc4_title')}
          </h3>
          <p className="text-neutral-500 mb-6 md:mb-8 text-sm leading-relaxed min-h-[3rem]" data-id="element-277">
            {t('svc4_desc')}
          </p>
          <div className="flex items-center" data-id="element-278">
            <span className="text-black font-medium text-sm border-b border-neutral-200 group-hover:border-black transition-colors pb-0.5" data-id="element-279">
              {t('svc4_price')}
            </span>
          </div>
        </div>

        {/* Service 5 */}
        <div className="group p-6 md:p-8 border-r border-b border-neutral-200 hover:bg-neutral-50 transition-all duration-300 cursor-pointer relative" onClick={scrollToContact} data-id="element-280">
          <div className="absolute top-6 md:top-8 right-6 md:right-8 opacity-0 group-hover:opacity-100 group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300" data-id="element-281">
            <ArrowUpRight className="h-4 md:h-5 w-4 md:w-5 text-black" data-id="element-282" />
          </div>
          <div className="mb-6 md:mb-8 group-hover:scale-110 transition-transform duration-300 origin-left" data-id="element-283">
            <Receipt className="h-5 md:h-6 w-5 md:w-6 text-black stroke-[1.5]" data-id="element-284" />
          </div>
          <h3 className="text-lg md:text-xl font-bold text-black mb-3 group-hover:underline decoration-1 underline-offset-4 transition-all" data-id="element-285">
            {t('svc5_title')}
          </h3>
          <p className="text-neutral-500 mb-6 md:mb-8 text-sm leading-relaxed min-h-[3rem]" data-id="element-286">
            {t('svc5_desc')}
          </p>
          <div className="flex items-center" data-id="element-287">
            <span className="text-black font-medium text-sm border-b border-neutral-200 group-hover:border-black transition-colors pb-0.5" data-id="element-288">
              {t('svc5_price')}
            </span>
          </div>
        </div>

        {/* Service 6 */}
        <div className="group p-6 md:p-8 border-r border-b border-neutral-200 hover:bg-neutral-50 transition-all duration-300 cursor-pointer relative" onClick={scrollToContact} data-id="element-289">
          <div className="absolute top-6 md:top-8 right-6 md:right-8 opacity-0 group-hover:opacity-100 group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300" data-id="element-290">
            <ArrowUpRight className="h-4 md:h-5 w-4 md:w-5 text-black" data-id="element-291" />
          </div>
          <div className="mb-6 md:mb-8 group-hover:scale-110 transition-transform duration-300 origin-left" data-id="element-292">
            <BookOpen className="h-5 md:h-6 w-5 md:w-6 text-black stroke-[1.5]" data-id="element-293" />
          </div>
          <h3 className="text-lg md:text-xl font-bold text-black mb-3 group-hover:underline decoration-1 underline-offset-4 transition-all" data-id="element-294">
            {t('svc6_title')}
          </h3>
          <p className="text-neutral-500 mb-6 md:mb-8 text-sm leading-relaxed min-h-[3rem]" data-id="element-295">
            {t('svc6_desc')}
          </p>
          <div className="flex items-center" data-id="element-296">
            <span className="text-black font-medium text-sm border-b border-neutral-200 group-hover:border-black transition-colors pb-0.5" data-id="element-297">
              {t('svc6_price')}
            </span>
          </div>
        </div>
      </div>

      <div className="mt-16 md:mt-24 flex items-center gap-4" data-id="element-298">
        <div className="h-px flex-1 bg-neutral-200" data-id="element-299"></div>
        <span className="text-xs text-neutral-400 uppercase tracking-wider text-center px-2" data-id="element-300">
          {t('services_footer')}
        </span>
        <div className="h-px flex-1 bg-neutral-200" data-id="element-301"></div>
      </div>
    </Section>;
}